import React from 'react'
import './StaticPages.css'
import staticBanner from '../../assets/images/about-us-banner.png'
import aboutmeimg from '../../assets/images/mid-banner.png'
import about1 from '../../assets/images/mkt-place-image1.png'
import about2 from '../../assets/images/second-about.png'
import about3 from '../../assets/images/third-about.png'
import ceoSpeaks from '../../assets/images/ceo-speaks-image.png'
import icon1 from '../../assets/images/buyicon.png'
import icon2 from '../../assets/images/sellicon.png'
import icon3 from '../../assets/images/financeicon.png'
import icon4 from '../../assets/images/auction.png'
import icon5 from '../../assets/images/valuationicon.png'
import media1 from '../../assets/images/media01.jpg'
import media2 from '../../assets/images/media-banner.png'
import media3 from '../../assets/images/media-placeholder.jpg'
import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
import ImageSlider from '@/custom/components/molecules/ImageSlider2'
import Review from '../Home/Review'
import '../../views/Home/Home.css'
const AboutUs = () => {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'About Us', link: '/about_us' },
    ]
    const reviews = [
        {
            description: 'This is an excellent product.',
            users_first_name: 'John',
            users_last_name: 'Doe',
            position: 'Software Engineer',
        },
        {
            description: 'The product is good but it has some issues that need to be addressed.',
            users_first_name: 'Jane',
            users_last_name: 'Smith',
            position: 'Product Manager',
        },
        {
            description:
                'I am not satisfied with the product. It did not meet my expectations and I found it quite lacking.',
            users_first_name: 'Bob',
            users_last_name: 'Johnson',
            position: 'Marketing Specialist',
        },
        {
            description: 'An average product. It works as advertised but nothing extraordinary.',
            users_first_name: 'Alice',
            users_last_name: 'Williams',
            position: 'UX Designer',
        },
        {
            description:
                'Fantastic product! I would highly recommend it to everyone. Great value for the price.',
            users_first_name: 'Michael',
            users_last_name: 'Brown',
            position: 'Sales Executive',
        },
    ]
    const valuedPartner = [
        { id: 1, image: '/images/brandImage.png' },
        { id: 2, image: '/images/brandImage.png' },
        { id: 3, image: '/images/brandImage.png' },
        { id: 4, image: '/images/brandImage.png' },
        { id: 5, image: '/images/brandImage.png' },
        { id: 6, image: '/images/brandImage.png' },
        { id: 7, image: '/images/brandImage.png' },
    ]
    return (
        <section className="terms-section">
            <div className="main-content">
                <div className="banner-section">
                    <div className="banner-image">
                        <img src={staticBanner} alt="Banner" className="banner-img" />
                    </div>
                    {/* <div className="banner-summary">
                        <div className="banner-text">
                            <h2>About Us</h2>
                        </div>
                    </div> */}
                </div>
                <div className="nav-path">
                    <div className="path-container">
                        <CustomBreadcrumbs items={breadcrumbs} />
                    </div>
                </div>
                <div className="content-area">
                    <div className="content-container">
                        <div className="terms-list spaced">
                            <p>
                                iQuippo Services Pvt. Ltd. is India&#39;s first and largest digital
                                marketplace for construction equipment, machinery, commercial
                                vehicles and services. Our marketplace allows buyers and sellers to
                                interact, negotiate and close transactions in a timely, transparent
                                and cost-effective manner.
                            </p>
                        </div>
                        <div className="aboutusImg mb-3">
                            <img src={aboutmeimg} alt="aboutimg" />
                        </div>
                        <div className="terms-box mb-3 p-3">
                            <div className="cardContainer">
                                <div className="title-section">
                                    A Marketplace For All Your Construction Needs!
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 right-side-content">
                                        <div className="block-level block-img">
                                            <img src={about1} alt="img1" />
                                        </div>
                                        <div className="block-level">
                                            <div className="subtitle">
                                                E-commerce for Equipment Industry
                                            </div>
                                            <div className="paragraph-sm">
                                                As a marketplace, iQuippo is providing a wider reach
                                                to original equipment manufacturers and thereby
                                                helping them connect with buyers to sell their new
                                                equipment. This surging online adoption, coupled
                                                with iQuippo’s seamless user experience is a big
                                                step forward in improving and expanding e-commerce
                                                for the equipment industry, matching up with a
                                                retail-like experience for the users.
                                            </div>
                                        </div>
                                        <div className="block-level block-img">
                                            <img src={about2} alt="img2" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 left-side-content">
                                        <div className="block-level">
                                            <div className="subtitle">
                                                Industry Specific Solutions
                                            </div>
                                            <div className="paragraph-sm">
                                                iQuippo has launched the industry specific solutions
                                                which have never been envisaged before, thereby
                                                kick-starting a transformational journey to deliver
                                                increased transparency, efficiency, and reliability
                                                in the industry.
                                            </div>
                                        </div>
                                        <div className="block-level block-img">
                                            <img src={about3} alt="img2" />
                                        </div>
                                        <div className="block-level">
                                            <div className="subtitle">
                                                Driving Better ROI with Enhanced Efficiency
                                            </div>
                                            <div className="paragraph-sm">
                                                iQuippo has developed proprietary tools for
                                                marketing and sales of equipment and
                                                market-connected dashboards, workflow tools that
                                                allow each stakeholder to centralize the activities,
                                                while improving their returns on investments and
                                                increasing efficiency.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="terms-box mb-3 p-0">
                            <div className="ceo-speaks-container">
                                <div className="card faded-card-shadow">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="ceo-img-block">
                                                <img
                                                    className="img-fluid"
                                                    src={ceoSpeaks}
                                                    alt="CEO"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="block-title ceo-speak-txt ceo-speak-txt2 text-right">
                                                Our <span className="ceo-txt-color">CEO</span>{' '}
                                                Speaks
                                            </div>
                                            <div className="ceo-msg-block">
                                                <div className="msg-quote">
                                                    We are always looking to evaluate and reassess
                                                    how we serve our customers and partners. In this
                                                    journey we have worked to revamp our marketplace
                                                    and make it user friendly for everyone. We truly
                                                    believe that in this VUCA world we need to be
                                                    agile and put our customers and partners&#39;
                                                    needs at the forefront and make it easier for
                                                    everyone to transact online. And this would
                                                    enable the industry to embrace technology more
                                                    easily.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="terms-box mb-3 p-0">
                            <div className="mkt-place-singlebanner">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h2 className="section-title">
                                            India&#39;s leading digital marketplace
                                        </h2>
                                        <div className="market-place-figures-block">
                                            <ul>
                                                <li>
                                                    <div className="figure-block">
                                                        1 LAC
                                                        <div className="fig-desc">
                                                            registered users
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="midlist">
                                                    <div className="figure-block">
                                                        1.5 MILLION
                                                        <div className="fig-desc">
                                                            annual website traffic
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="figure-block">
                                                        30,000 +
                                                        <div className="fig-desc">
                                                            equipment valuation
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="figure-block">
                                                        10,000 +
                                                        <div className="fig-desc">
                                                            Equipment Sold
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="midlist">
                                                    <div className="figure-block">
                                                        15,000 +
                                                        <div className="fig-desc">
                                                            Equipment Financed
                                                        </div>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="figure-block">
                                                        3,000 +
                                                        <div className="fig-desc">Auctions</div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="terms-box p-3 mb-3">
                            <div className="faded-card-shadow">
                                <div className="section-title">
                                    iQuippo streamlines project planning and implementation
                                </div>
                                <div className="mt-2">
                                    We manage end-to-end asset lifecycle with numerous products at
                                    each stage.
                                </div>
                                <ul>
                                    <li>
                                        <div className="circleimg">
                                            <img
                                                className="img-fluid"
                                                src={icon1}
                                                alt="Buy Equipment"
                                            />
                                        </div>
                                        <p>
                                            <a href="">Buy Equipment</a>
                                        </p>
                                    </li>
                                    <li>
                                        <div className="circleimg">
                                            <img
                                                className="img-fluid"
                                                src={icon2}
                                                alt="Sell Equipment"
                                            />
                                        </div>
                                        <p>
                                            <a href="">Sell Equipment</a>
                                        </p>
                                    </li>
                                    <li>
                                        <div className="circleimg">
                                            <img
                                                className="img-fluid"
                                                src={icon3}
                                                alt="Finance Equipment"
                                            />
                                        </div>
                                        <p>
                                            <a href="">Financing Equipment</a>
                                        </p>
                                    </li>
                                    <li>
                                        <div className="circleimg">
                                            <img
                                                className="img-fluid"
                                                src={icon4}
                                                alt="Auction Equipment"
                                            />
                                        </div>
                                        <p>
                                            <a href="/auctionsList">Auction Equipment</a>
                                        </p>
                                    </li>
                                    <li>
                                        <div className="circleimg">
                                            <img
                                                className="img-fluid"
                                                src={icon5}
                                                alt="Valuate Equipment"
                                            />
                                        </div>
                                        <p>
                                            <a href="">Valuating Equipment</a>
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <section className="searchEquip sectionContainer customContainer p-0">
                            <div className="oemContainer" style={{ background: '#ffffff' }}>
                                <div className="oemHeaderCnt d-flex justify-content-between align-items-center">
                                    <h3 className="mb-0 font-change-oem">Our Valued Partner</h3>
                                    {/* <Button>View All</Button> */}
                                </div>

                                <div className="oemGrid mt-4">
                                    <ImageSlider images={valuedPartner} type={'partner'} />
                                </div>
                            </div>
                        </section>

                        <div className="terms-box p-3 mb-3">
                            <div className="faded-card-shadow">
                                <div className="row mb-3">
                                    <div className="col-sm-6 col-8 section-title">Media</div>
                                    <div className="col-sm-6 col-4 view-all-btn-block">
                                        <button className="d-none mat-focus-indicator mat-stroked-button mat-button-base">
                                            <span className="mat-button-wrapper">View All</span>
                                            <span className="mat-button-ripple mat-ripple"></span>
                                            <span className="mat-button-focus-overlay"></span>
                                        </button>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12 col-md-6 position-relative">
                                        <a
                                            href="https://www.linkedin.com/posts/asiaone_beseenbeheard-asaionemagazine-media-activity-6838340950167740417-p4gO/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                className="img-fluid banner-main-media"
                                                src={media1}
                                                alt="Media Banner 1"
                                            />
                                            <div className="overlay-block"></div>
                                            <div className="overlay-text">
                                                <p>
                                                    Mr. Anant Kanoria is recognized by AsiaOne
                                                    Magazine and is going to be felicitated with the
                                                    Most Influential Young Leaders 2020-21 Awards.
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-12 col-md-6 mt-3 mt-md-0">
                                        <div className="position-relative right-media-img-block">
                                            <a
                                                href="https://www.ceoinsightsindia.com/magazines/best-startups-to-watch-for-august-2021/#page=42"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className="img-fluid mb-3"
                                                    src={media2}
                                                    alt="Media Banner 2"
                                                />
                                                <div className="overlay-block"></div>
                                                <div className="overlay-text">
                                                    <p>
                                                        First Digital Indian platform to offer
                                                        marketplace for construction equipment and
                                                        machinery
                                                    </p>
                                                </div>
                                            </a>
                                        </div>

                                        <div className="position-relative right-media-img-block">
                                            <a
                                                href="/assets/CorporateVisionIssue122020-Jul20136.pdf"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className="img-fluid mb-3"
                                                    src={media3}
                                                    alt="Media Banner 3"
                                                />
                                                <div className="overlay-block"></div>
                                                <div className="overlay-text">
                                                    <p>
                                                        Best Online Construction Equipment &amp;
                                                        Services Platform in India’, we took a
                                                        closer look at iQuippo and its offering.
                                                    </p>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="searchEquip sectionContainer customContainer p-0 text-center">
                            <div className="loanContainer">
                                <div className="loanHeaderCnt d-flex justify-content-between align-items-center">
                                    <h3 className="mb-0">Testimonials</h3>
                                </div>
                                <div className="reviewGrid mt-4">
                                    <Review data={reviews} />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutUs
